import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M13.542 10a3.542 3.542 0 1 1-7.084 0 3.542 3.542 0 0 1 7.084 0ZM8.958 3.958h2.084M8.958 16.042h2.084M10 4.167v1.875m0 7.916v1.875m3.536-10.842 1.473 1.473M4.991 13.536l1.473 1.473m7.661-9.134-1.326 1.326m-5.598 5.598-1.326 1.326m10.167-5.167v2.084M3.958 8.958v2.084M15.833 10h-1.875m-7.916 0H4.167m10.842 3.536-1.473 1.473M6.464 4.991 4.991 6.464m9.134 7.661-1.326-1.326M7.201 7.201 5.875 5.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);